export default __webpack_public_path__ + "static/char-v-37-83d6450474a24152b8ea8616995f3c4b.webp";